import { Validator } from '@vista-digital/validator';
/**
 * Default configuration for the Film Trailer component.
 */
export const defaultFilmTrailerConfig = {
    showControls: true,
    autoPlay: true,
    muted: false,
    loop: false
};
export const filmTrailerConfigValidatorSchema = {
    showControls: Validator.boolean(),
    autoPlay: Validator.boolean(),
    muted: Validator.boolean(),
    loop: Validator.boolean()
};
export const filmTrailerConfigValidator = Validator.object(filmTrailerConfigValidatorSchema);
